function injectStyle (ssrContext) {
  require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-32b825d6\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-32b825d6\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 99
// module chunks = 1